import React from 'react'
import { P } from 'konsys-ui'
import Container from '../../components/home'
import { CenteredSection } from '../../components/common/layout'

export class HomePage extends React.PureComponent {
  render() {
    return (
      <div>
        <CenteredSection>
          <Container />
          <P>Testtt</P>
        </CenteredSection>
      </div>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/pages/landing/index.jsx